<template>
  <!-- 标签数小于等于1时不展示标签 -->
    <div v-if="tabs.length > 1" class="tab">
      <div
        class="tab-header"
        :class="{ 'scrollable': isScrollable }"
        ref="tabContainer"
        @mousedown="onMouseDown"
        @touchstart="onTouchStart"
      >
        <div
          class="tab-header-item"
          :style="{'--activeColor':activeColor,
          '--deActiveColor':deActiveColor,
          '--deActiveBg':`url(${deActiveBg})`,
          '--activeBg':`url(${activeBg})`,
          '--width':width,
          '--height':height,
          '--fontSize':fontSize,
          '--marginRight':tabs.length > 2 ? '8px' : '45px'
          }"
          v-for="(item, index) in tabs"
          :key="`${item.strategyId}${index}`"
          :class="{ active: activeIndex === index }"
          @click="scrollToCenter(index)"
        >
          {{ limitText(item.labelName) }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    props:{
        tabs:{
            type:Array,
            default:()=>{
                return []
            }
        },
        activeColor:{//选中色值
          type:String,
          default:'#ffffff'
        },
        deActiveColor:{//未选中色值
          type:String,
          default:'#FF5188'
        },
        activeBg:{//选中背景
          type:String,
          default:`${require('../img/active.png')}`
        },
        deActiveBg:{//未选中背景
          type:String,
          default:`${require('../img/deActive.png')}`
        },
        componentConfig: {
          type: Object,
          default: () => {},
        },
        pageConfig: {
          type: Object,
          default: () => {},
        }
    },
    computed:{
      ...mapState(["commonStore","resumeStore"]),
      limitText() {
      return function(text, maxLength = 5) {
        return text.length > maxLength ? `${text.slice(0, maxLength)}` : text;
      };
    }
    },
    data() {
      return {
        containerWidth: 0,//tab宽度
        isScrollable: false,//是否超出滚动
        tabWidth: 103, // 默认 h5端Tab宽度
        tabWidthLarge: 155, // pc端Tab宽度
        width:'103px',
        height:'44px',
        fontSize:'14px',
        marginRight:'8px',
        isDragging: false,
        startX: 0,
        scrollLeft: 0,
        activeIndex: 0, // 选中的 Tab 索引
      };
    },
    mounted() {
      this.$sensors.track("WidgetShow", {
        bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`
          },
        $element_id: "sensor_bcop_tabs",
      });
      this.updateTabState();
      window.addEventListener("resize", this.updateTabState);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.updateTabState);
    },
    methods: {
      updateTabState() {
        if(this.tabs.length > 1){
          this.$nextTick(() => {
          if (this.$refs.tabContainer) {
            this.containerWidth = this.$refs.tabContainer.offsetWidth;
            const currentTabWidth = this.commonStore.isForPC ? this.tabWidthLarge : this.tabWidth;            
            const totalTabsWidth = this.tabs.length * currentTabWidth;
            this.isScrollable = totalTabsWidth > this.containerWidth;
            this.width =  this.commonStore.isForPC ? '155px' : '103px';
            this.height =  this.commonStore.isForPC ? '66px' : '44px'
            this.fontSize = this.commonStore.isForPC ? '21px' : '14px'
          }
        });
        }
      },
  
      // 点击 Tab 让其居中
      scrollToCenter(index) {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_tabs",
          contentName: this.tabs[index].labelName,
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
          }
        });
        this.activeIndex = index;
        this.$nextTick(() => {
          const tabContainer = this.$refs.tabContainer;
          const tabItems = tabContainer.children;
          if (!tabContainer || !tabItems[index]) return;
  
          const tab = tabItems[index];
          const tabRect = tab.getBoundingClientRect();
          const containerRect = tabContainer.getBoundingClientRect();
          
          const scrollOffset = tabContainer.scrollLeft + tabRect.left - containerRect.left - (containerRect.width / 2) + (tabRect.width / 2);
  
          tabContainer.scrollTo({
            left: scrollOffset,
            behavior: "smooth",
          });
          this.$emit('changeTab',this.tabs[this.activeIndex])
        });
      },
  
      // PC 端鼠标拖动
      onMouseDown(event) {
        if (!this.isScrollable) return;
        this.isDragging = true;
        this.startX = event.pageX - this.$refs.tabContainer.offsetLeft;
        this.scrollLeft = this.$refs.tabContainer.scrollLeft;
        document.addEventListener("mousemove", this.onMouseMove);
        document.addEventListener("mouseup", this.onMouseUp);
      },
      onMouseMove(event) {
        if (!this.isDragging) return;
        const x = event.pageX - this.$refs.tabContainer.offsetLeft;
        const walk = (x - this.startX) * 1.5; // 控制滚动速度
        this.$refs.tabContainer.scrollLeft = this.scrollLeft - walk;
      },
      onMouseUp() {
        this.isDragging = false;
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.onMouseUp);
      },
  
      // 移动端触摸滚动（兼容性增强）
      onTouchStart(event) {
        if (!this.isScrollable) return;
        this.startX = event.touches[0].pageX;
        this.scrollLeft = this.$refs.tabContainer.scrollLeft;
        document.addEventListener("touchmove", this.onTouchMove);
        document.addEventListener("touchend", this.onTouchEnd);
      },
      onTouchMove(event) {
        const x = event.touches[0].pageX;
        const walk = (x - this.startX) * 1.5;
        this.$refs.tabContainer.scrollLeft = this.scrollLeft - walk;
      },
      onTouchEnd() {
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      },
    },
  };
  </script>
  
<style scoped lang="less">
.tab {
  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
  }
  .tab-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 7.9px;
    white-space: nowrap;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;
    user-select: none; /* 禁止选中文字 */

    &::-webkit-scrollbar {
      display: none;
    }

    .tab-header-item {
      width: var(--width);
      height: var(--height);
      font-size: var(--fontSize);
      font-weight: 500;
      color: var(--deActiveColor);
      padding-bottom: 6.11px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      // margin-right: var(--marginRight);
      transition: background-color 0.3s;
      cursor: pointer;
      background: var(--deActiveBg);

      background-size: contain;
      background-repeat: no-repeat;

      &.active {
        font-size: var(--fontSize);
        font-weight: 600;
        width: var(--width);
        height: var(--height);
        box-sizing: border-box;
        padding-bottom: 6.11px;
        color: var(--activeColor);
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--activeBg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .tab-header-item:first-child{
      margin-left: 12px;
    }
    .tab-header-item:not(:last-child){
      margin-right: var(--marginRight);

    }
  }

  /* 超出宽度时启用滚动 */
  .scrollable {
    justify-content: flex-start;
    overflow-x: auto;
    cursor: grab;
  }

  /* 鼠标拖动状态 */
  .scrollable:active {
    cursor: grabbing;
  }
}
</style>